/* tslint:disable */
/* eslint-disable */
/**
 * CourierApi
 * CourierApi
 *
 * The version of the OpenAPI document: 2.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MailOption
 */
export interface MailOption {
    /**
     * 
     * @type {string}
     * @memberof MailOption
     */
    host?: string;
    /**
     * 
     * @type {number}
     * @memberof MailOption
     */
    port?: number;
    /**
     * 
     * @type {boolean}
     * @memberof MailOption
     */
    secure?: boolean;
    /**
     * 
     * @type {string}
     * @memberof MailOption
     */
    user?: string;
    /**
     * 
     * @type {string}
     * @memberof MailOption
     */
    password?: string;
    /**
     * 
     * @type {boolean}
     * @memberof MailOption
     */
    rejectUnauthorized?: boolean;
    /**
     * 
     * @type {string}
     * @memberof MailOption
     */
    sendGridApiKey?: string;
    /**
     * 
     * @type {number}
     * @memberof MailOption
     */
    method?: number;
    /**
     * 
     * @type {string}
     * @memberof MailOption
     */
    from?: string;
    /**
     * 
     * @type {number}
     * @memberof MailOption
     */
    id?: number;
    /**
     *
     * @type {number}
     * @memberof MailOption
     */
    courierId?: number;
    /**
     * Email provider choice: zoho, mailgun, or smtp
     * @type {string}
     * @memberof MailOption
     */
    emailProvider?: string;
}

/**
 * Check if a given object implements the MailOption interface.
 */
export function instanceOfMailOption(value: object): value is MailOption {
    return true;
}

export function MailOptionFromJSON(json: any): MailOption {
    return MailOptionFromJSONTyped(json, false);
}

export function MailOptionFromJSONTyped(json: any, ignoreDiscriminator: boolean): MailOption {
    if (json == null) {
        return json;
    }
    return {
        
        'host': json['host'] == null ? undefined : json['host'],
        'port': json['port'] == null ? undefined : json['port'],
        'secure': json['secure'] == null ? undefined : json['secure'],
        'user': json['user'] == null ? undefined : json['user'],
        'password': json['password'] == null ? undefined : json['password'],
        'rejectUnauthorized': json['rejectUnauthorized'] == null ? undefined : json['rejectUnauthorized'],
        'sendGridApiKey': json['sendGridApiKey'] == null ? undefined : json['sendGridApiKey'],
        'method': json['method'] == null ? undefined : json['method'],
        'from': json['from'] == null ? undefined : json['from'],
        'id': json['id'] == null ? undefined : json['id'],
        'courierId': json['courierId'] == null ? undefined : json['courierId'],
        'emailProvider': json['emailProvider'] == null ? undefined : json['emailProvider'],
    };
}

export function MailOptionToJSON(json: any): MailOption {
    return MailOptionToJSONTyped(json, false);
}

export function MailOptionToJSONTyped(value?: MailOption | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'host': value['host'],
        'port': value['port'],
        'secure': value['secure'],
        'user': value['user'],
        'password': value['password'],
        'rejectUnauthorized': value['rejectUnauthorized'],
        'sendGridApiKey': value['sendGridApiKey'],
        'method': value['method'],
        'from': value['from'],
        'id': value['id'],
        'courierId': value['courierId'],
        'emailProvider': value['emailProvider'],
    };
}

